/**
 * @param {unknown} payload
 * @param {string} [fallback]
 * @returns {string}
 */
export function getApiResponseMessage(payload, fallback = "") {
  if (!payload) return fallback;
  if (typeof payload === "string") {
    const trimmed = payload.trim();
    return trimmed || fallback;
  }
  if (typeof payload === "object") {
    const msg =
      payload.message ??
      payload.msg ??
      payload.data?.message ??
      payload.data?.msg;
    if (typeof msg === "string" && msg.trim()) return msg.trim();
  }
  return fallback;
}

/**
 * @param {unknown} error
 * @param {string} [fallback]
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback = "") {
  if (!error) return fallback;
  if (typeof error === "string") {
    const trimmed = error.trim();
    return trimmed || fallback;
  }
  if (typeof error === "object") {
    const msg = error.message;
    if (typeof msg === "string" && msg.trim()) return msg.trim();
    if (error.errors && typeof error.errors === "object") {
      for (const val of Object.values(error.errors)) {
        const item = Array.isArray(val) ? val[0] : val;
        if (typeof item === "string" && item.trim()) return item.trim();
      }
    }
  }
  return fallback;
}

/**
 * Map backend validation text to form field keys when possible.
 * @param {string} message
 * @returns {Record<string, string>}
 */
export function getApiErrorFieldHints(message) {
  if (!message || typeof message !== "string") return {};
  const hints = {};
  const lower = message.toLowerCase();
  if (lower.includes("email") || message.includes("البريد")) {
    hints.email = message;
  }
  if (
    lower.includes("phone") ||
    message.includes("الهاتف") ||
    message.includes("جوال")
  ) {
    hints.phone = message;
  }
  return hints;
}
